import React from "react";
import { useMsal } from "@azure/msal-react";
import styles from "./index.module.scss";
import DownloadAppSection from "../DownloadAppSection";

// Microsoft Windows Logo SVG
const MicrosoftLogo = () => (
  <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
  </svg>
);

export const LoginPage: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect();
  };

  return (
    <div className={styles.pageContainer} style={{ backgroundImage: "url('/imgs/bg-login.png')" }}>
      <div className={styles.overlay}></div>

      <div className={styles.contentWrapper}>
        <div className={styles.loginCard}>
          {/* Left Panel - Login Form */}
          <div className={styles.leftPanel}>
            <div className={styles.logoWrapper}>
              <img src="/assets/images/logo.png" alt="VIAGS Logo" className={styles.logo} />
            </div>

            <h1 className={styles.welcomeTitle}>Chào mừng bạn quay trở lại</h1>
            <p className={styles.welcomeSubtitle}>Đăng nhập để tiếp tục sử dụng dịch vụ</p>

            <button className={styles.microsoftButton} onClick={handleLogin}>
              <MicrosoftLogo />
              <span>Đăng nhập bằng Microsoft</span>
            </button>
          </div>

          {/* Right Panel - App Promo */}
          <div className={styles.rightPanel}>
            <DownloadAppSection />
          </div>
        </div>
      </div>
    </div>
  );
};
